export const types = {
  SET_IS_AUTH: 'auth/SET_IS_AUTH' as const,
  SET_ROLE_SCREEN: 'auth/SET_ROLE_SCREEN' as const,
  REQUEST_ROLE_SCREEN: 'auth/REQUEST_ROLE_SCREEN' as const,
  RESOLVE_ROLE_SCREEN: 'auth/RESOLVE_ROLE_SCREEN' as const,
  FAIL_ROLE_SCREEN: 'auth/FAIL_ROLE_SCREEN' as const,
};

export const setIsAuth = (payload: boolean) => ({
  type: types.SET_IS_AUTH,
  payload,
});

export const setRoleScreen = (payload: Object) => ({
  type: types.SET_ROLE_SCREEN,
  payload,
});

export const requestRoleScreen = (payload: { path: string; requestId: string }) => ({
  type: types.REQUEST_ROLE_SCREEN,
  payload,
});

export const resolveRoleScreen = (payload: { path: string; requestId: string; roleScreen: Object }) => ({
  type: types.RESOLVE_ROLE_SCREEN,
  payload,
});

export const failRoleScreen = (payload: { path: string; requestId: string }) => ({
  type: types.FAIL_ROLE_SCREEN,
  payload,
});

type Actions = (
    | ReturnType<typeof setIsAuth>
    | ReturnType<typeof setRoleScreen>
    | ReturnType<typeof requestRoleScreen>
    | ReturnType<typeof resolveRoleScreen>
    | ReturnType<typeof failRoleScreen>
    );

export default Actions;
